import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: () => import('@/views/MainPage.vue'),
    meta: {
      title: '体感座椅_模拟器_赛车游戏_模拟飞行_域禾云风KWTEC-专业六轴运动平台解决方案',
      description: '域禾云风KWTEC专业研发生产体感座椅、六轴平台、模拟器，提供赛车游戏、模拟飞行、DCS、微软飞行模拟器等沉浸式体验解决方案。'
    }
  },
  {
    path: '/six-axis-motion-platform',
    name: 'SixAxisMotionPlatform',
    component: () => import('@/views/Product_A.vue'),
    meta: {
      title: '域禾云风KWTEC 6DOF六轴体感座椅模拟器_赛车游戏模拟飞行专用',
      description: '域禾云风KWTEC 6DOF六轴体感座椅模拟器，专业为赛车游戏、DCS模拟飞行、微软飞行模拟器等设计，提供真实沉浸体验。'
    }
  },
  {
    path: '/controller-software',
    name: 'ControllerSoftware',
    component: () => import('@/views/SoftwarePage.vue'),
    meta: {
      title: '域禾云风KWTEC 控制器启动软件_六轴平台配置工具',
      description: '域禾云风KWTEC 控制器启动软件，为六轴平台和体感座椅提供便捷的配置和控制功能，支持Windows x64平台。'
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
        top: 70 // 额外偏移量，避免内容被导航栏遮挡
      }
    } else {
      return { top: 0 }
    }
  }
})

export default router 